import MessageBus from "message-bus-client";
import { disableImplicitInjections } from "discourse/lib/implicit-injections";
const MessageBusService = dt7948.c(class MessageBusService {
  static isServiceFactory = true;
  static create() {
    return MessageBus;
  }
}, [disableImplicitInjections]);
export default MessageBusService;